module.exports = __webpack_public_path__ + "img/obwan-logo-transparent.17d95f58.png";